import React, { useState } from 'react';
import client from '../api/client';
import { Button, Input, message, Spin } from 'antd';
import styles from './Blog.module.css';

const API_BASE = '/blog';

export default function BlogWriter() {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!title.trim()) {
      message.error('عنوان الزامی است.');
      return;
    }
    if (content.trim().length < 50) {
      message.error('محتوا باید حداقل ۵۰ حرف باشد.');
      return;
    }

    setLoading(true);
    try {
      await client.post(`${API_BASE}/`, {
        title: title.trim(),
        content: content.trim()
      });
      message.success('مقاله شما برای تایید ثبت شد!');
      setTitle('');
      setContent('');
    } catch (err) {
      const msg = err.response?.data?.message || 'خطا در ارسال مقاله';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <div className={styles.writer}>
        <h2>نوشتن مقاله</h2>
        <Input
          placeholder="عنوان مقاله"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          maxLength={500}
          className={styles.titleInput}
        />
        <textarea
          placeholder="محتوای مقاله (حداقل ۵۰ حرف)"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          maxLength={50000}
          rows={15}
          className={styles.contentInput}
        />
        <div className={styles.charCount}>
          {content.length}/50000
        </div>
        <Button type="primary" onClick={handleSubmit} disabled={loading}>
          ارسال برای تایید
        </Button>
      </div>
    </Spin>
  );
}
